/* Daylight · "Finish it off" bag add-ons (ELYSIAN).
   Oct 18 (John: "I added matches and it did not add to the cart or total"): this handler used to sit inside the add-ons
   snippet, so it only ran when the page loaded with something already in the bag. After a first add, the bag drawer is
   redrawn from HTML, its scripts never run, and Add did nothing. It now loads on every page.
   Fancy Matches needs a design on its product page; from the bag it is added with the design that needs no lettering
   (Vertical stripes) and no extra bag, saved the same way Key Product Options saves them, so the order is complete. */
(function () {
  if (window.__dlAddonsBound) return;
  window.__dlAddonsBound = true;
  var keyOptions = function (list) {
    var p = {};
    list.forEach(function (o) { p[o.name] = o.value; });
    p._key_all_property_values = JSON.stringify(list.map(function (o) {
      return { name: o.name, value: o.value, price: 0, variantId: '0', optionId: o.id };
    }));
    return p;
  };
  var PROPS = {
    fancymatches: keyOptions([
      { name: 'Choose a design for your fancy matches vase', value: 'Vertical stripes', id: 21966 },
      { name: 'Add an extra bag of matchsticks?', value: 'No thanks', id: 21967 }
    ])
  };
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dl-addon-add]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-dl-addon]');
    var wrap = btn.closest('[data-dl-addons]');
    var field = row && row.querySelector('[data-dl-addon-variant]');
    if (!field) return;
    var item = { id: Number(field.value), quantity: 1 };
    var props = PROPS[row.getAttribute('data-handle')];
    if (props) item.properties = props;
    var err = row.querySelector('[data-dl-addon-err]');
    if (err) err.hidden = true;
    btn.disabled = true;
    btn.textContent = 'Adding';
    /* lower-case "post" on purpose: Key Product Options checks its own product form on any "POST" to the cart */
    fetch(root() + 'cart/add.js', {
      method: 'post',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      if (wrap && wrap.getAttribute('data-mode') === 'page') { window.location.reload(); return; }
      var cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.refreshCartDrawer === 'function') cd.refreshCartDrawer();
      else document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
      fetch(root() + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-dl-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
    }).catch(function (j) {
      btn.disabled = false;
      btn.textContent = 'Add';
      if (err) {
        err.textContent = (j && (j.description || j.message)) || "We couldn't add that. Please try again.";
        err.hidden = false;
      }
    });
  });
})();
